export const expressSLATableHeader = [
  {
    field: 'ID',
    label: 'Order ID',
    centered: true
  },
  {
    field: 'DriverName',
    label: 'Driver Name',
    centered: true
  },
  {
    field: 'Distance',
    label: 'Distance',
    centered: true
  },
  {
    field: 'SlotTimeText',
    label: 'Slot',
    centered: true
  },
  {
    field: 'Start',
    label: 'Start',
    centered: true
  },
  {
    field: 'End',
    label: 'Success Time',
    centered: true
  },
  {
    field: 'Level',
    label: 'SLA',
    centered: true
  },
  {
    field: 'Duration',
    label: 'Duration (minute)',
    centered: true
  },
  {
    field: 'Branch',
    label: 'Branch',
    centered: true
  }
]
